import React, { useCallback, useEffect, useState } from "react";
import { serviceHealthTipsDetail } from "../../../services/HealthTips.service";
import { useParams } from "react-router";
import history from "../../../libs/history.utils";
import RouteName from "../../../routes/Route.name";

function useHealthTipsDetail() {
  const [data, setData] = useState({});
  const { id } = useParams();
  useEffect(() => {
    if (id) {
        serviceHealthTipsDetail({ id }).then((res) => {
        if (!res?.error) {
          const response = res?.data?.details;
          setData(response);
        }
      });
    }
  }, [id]);

  const handleEdit = useCallback(() => {
    history.push(RouteName.HEALTH_UPDATE + id);
  }, [id]);

  const handleCopy = useCallback(() => {
    history.push(`${RouteName.HEALTH_UPDATE}${id}`,{"is_duplicate":true});
  }, []);

  return {
    data,
    handleEdit,
    handleCopy
  };
}

export default useHealthTipsDetail;
